module.exports = __webpack_public_path__ + "static/media/bgHangover.99b3d3b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgHangover.png
// module id = 1284
// module chunks = 0